import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {StyleSheet, View, Text, Pressable} from 'react-native';
import {Svg, Path} from 'react-native-svg';
import {SafeAreaView} from 'extensions/viewport/SafeArea';
import filesystem from 'extensions/filesystem';
import {vectors, colors} from 'config/styles';
import {selectors} from 'store/slices/files';
import {isWeb} from 'utils/platform';
import {slices} from 'store';

export function FileLoader() {
  const {t} = useLingui();
  const preview = useSelector(selectors.getPreview);
  const progress = useSelector(selectors.getPreviewProgress);
  const classes = {
    barProgress: [
      styles.barProgress,
      {width: isNaN(progress) ? 0 : progress},
      isWeb() && {['transition' as any]: 'width 0.5s ease'},
    ],
  };

  const dispatch = useDispatch();
  const cancel = useCallback(() => {
    dispatch(slices.files.actions.previewClose());
    try {
      filesystem.cancelDownload(preview.jobId);
    } catch (e) {}
  }, [preview.jobId]);

  return (
    <View style={styles.root}>
      <SafeAreaView style={{flex: 1, backgroundColor: colors.neutral.darker}}>
        <View style={styles.header}>
          <Text style={styles.title}>
            {t`Downloading File`}
          </Text>
          <View style={styles.close}>
            <Pressable onPress={cancel}>
              <Svg viewBox="0 0 20 20" width={24} height={24}>
                <Path d={vectors.icons.close} fill={colors.neutral.white}/>
              </Svg>
            </Pressable>
          </View>
        </View>
        <View style={styles.wrapper}>
          <View style={styles.content}>
            <Text style={styles.message}>
              {preview.name}
            </Text>
            <View style={styles.progress}>
              <View style={styles.bar}>
                <View style={classes.barProgress}/>
              </View>
            </View>
          </View>
        </View>
      </SafeAreaView>
    </View>
  );
}

export const styles = StyleSheet.create({
  root: {
    flex: 1,
    position: 'absolute',
    flexDirection: 'row',
    backgroundColor: colors.neutral.white,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  header: {
    flex: 0,
    height: 65,
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginLeft: 26,
    color: colors.neutral.white,
    fontSize: 18,
    flex: 1,
  },
  close: {
    width: 65,
    height: 65,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  wrapper: {
    flex: 1,
    justifyContent: 'center',
  },
  content: {
    flex: 0,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  message: {
    color: colors.neutral.white,
    marginBottom: 14,
    textAlign: 'center',
  },
  progress: {
    flex: 0,
    width: 100,
  },
  bar: {
    position: 'relative',
    flex: 0,
    height: 6,
    borderRadius: 3,
    backgroundColor: colors.neutral.mid,
  },
  barProgress: {
    position: 'absolute',
    flex: 0,
    top: 0,
    bottom: 0,
    left: 0,
    borderRadius: 3,
    backgroundColor: colors.primary.brand,
  },
});
